import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The Angry Walk",
  "description": "",
  "published": "2008-01-29T00:00:00.000Z",
  "redirect_from": ["/blog/the-angry-walk/swizec/131"],
  "categories": "food for thought",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You know that feeling when you say or do something and suddenly your bird storms off into the distance and you are left standing there like a moron with nothing but the cold air and condescending looks around you? I'm sure every guy out there knows about it, but do you know what to do when it happens?`}</p>
    <p>{`Well first off let me just mention that doing what I tell you to do does not necessarily mean you aren't a total arse and that you are now free to do anything you want to your girlfriends just because you know how to clear yourself of any implications. Don't be me. Only I'm allowed to do that.`}</p>
    <p>{`Right, so there's a video example ... in very poor quality, with shaky hands and ... well it's a cell phone video, cut me some slack.`}</p>
    <p>{`The shooting began right after I was punched in the abdomen, she punches like a girl thankfully, and the storming off happened. A regular offender might stand there dumbstruck, but my deep knowledge of human female behaviour told me immediately what I was to do. I needed to follow, but keep my distance. Remember, don't be pushy or try to run after her, don't even say anything. Just follow.`}</p>
    <p>{`Oh I also videotaped because it felt like there was some artsy fartsy beauty in it.`}</p>
    <p>{`At first the distance greatens, but you must keep walking at regular pace. Do not panic like a normal speeder would do. She's panicking enough for the both of you, keep calm. Quite soon, however, she will magically begin to slow her pace. This is when the initial emotional reaction begins to subside and she once again needs your hug. Do not get antsy, keep walking at regular pace and the distance will do what it's ought to do. It will remove itself from the equation. Now is the time for you to drag it out a little bit, walk just behind her for a while, just a little bit quicker than she is.`}</p>
    <p>{`When it becomes too difficult to walk slow enough to keep away. Stop. Stop keeping away that is. This is the time where you hug her and do whatever else it is that she needs. Appologise. Admit that yes you did go out with a hooker or that yes, it was you who left the baby in the fridge on accident.`}</p>
    <p>{`Disclaimer: this might not work with all models of human females.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      